import styled from "styled-components";

export const DescriptionText = styled.span<{color: string}>`
    font-family: HelveticaLight;
    color: ${(props) => props.color};
    font-size: 16px;
    line-height: 25px;
`;